/**
 * Public TripMaster checkout split-card checks.
 * Sequential unpaid empty slots are allowed; when every selected card has an amount,
 * the agorot sum must equal the payable total.
 */
import { ilsToAgorot, agorotToIls } from "./publicMoneyAgorot";

export const PUBLIC_SPLIT_MAX_CARDS = 4;

function toMoney(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

export function roundPublicSplitIls(value) {
  const a = ilsToAgorot(value);
  if (a == null) return null;
  return agorotToIls(a);
}

export function evaluatePublicSplitCardAmounts({
  cards,
  payableTotal,
  maxCards = PUBLIC_SPLIT_MAX_CARDS,
} = {}) {
  const list = Array.isArray(cards) ? cards : [];
  const payable = toMoney(payableTotal);
  const payableAgorot = payable != null && payable > 0 ? ilsToAgorot(payable) : null;
  const payableRounded = payableAgorot != null ? agorotToIls(payableAgorot) : null;

  if (list.length > maxCards) {
    return {
      ok: false,
      code: "too_many_cards",
      cardCount: list.length,
      payableRounded,
      filledSumRounded: null,
    };
  }

  const negatives = list.filter((c) => toMoney(c?.amount) != null && Number(c.amount) < 0);
  if (negatives.length > 0) {
    return {
      ok: false,
      code: "negative_amount",
      cardCount: list.length,
      payableRounded,
      filledSumRounded: null,
    };
  }

  const filled = list.filter((c) => {
    const n = toMoney(c?.amount);
    return n != null && n > 0;
  });
  const filledSumAgorot = filled.reduce((acc, c) => acc + (ilsToAgorot(c.amount) || 0), 0);
  const filledSumRounded = agorotToIls(filledSumAgorot);

  if (list.length === 0 || filled.length === 0) {
    return {
      ok: false,
      code: "missing_amount",
      cardCount: list.length,
      payableRounded,
      filledSumRounded,
    };
  }

  if (payableAgorot != null && filled.length === list.length) {
    if (filledSumAgorot !== payableAgorot) {
      return {
        ok: false,
        code: "sum_mismatch",
        cardCount: list.length,
        payableRounded,
        filledSumRounded,
      };
    }
  }

  if (payableAgorot != null && filledSumAgorot > payableAgorot) {
    return {
      ok: false,
      code: "sum_exceeds_payable",
      cardCount: list.length,
      payableRounded,
      filledSumRounded,
    };
  }

  return {
    ok: true,
    code: "ok",
    cardCount: list.length,
    payableRounded,
    filledSumRounded,
  };
}
